new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if(contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');
            let mobileThumbs = document.querySelector('.product-detail__header--photoArea-mobile-thumbs');
            let mobilePhoto = document.querySelector('.product-detail__header--photoArea-mobile-photo');
            if(photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');
    
                    if(photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');
    
                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                              content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }
        
                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                              activeTab(index);
                            });
                        });
                    }
                }
            }

            if(photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }

            if (mobilePhoto && mobileThumbs) {
                let mobilePhotoListItem = mobileThumbs.querySelectorAll('li');
                let mobileSinglePhoto = mobilePhoto.querySelectorAll('li');

                if (mobilePhotoListItem && mobileSinglePhoto) {
                    mobilePhotoListItem[0].classList.add('active');
                    mobileSinglePhoto[0].classList.add('active');

                    function activeTab(index) {
                        mobileSinglePhoto.forEach((content) => {
                          content.classList.remove('active');
                        });
                        mobileSinglePhoto[index].classList.add('active');
                    }
    
                    mobilePhotoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => {
                          activeTab(index);
                        });
                    });
                }

                // Seleciona todos os li com class "youtube-thumb"
                var $youtubeThumbs = $('.youtube-thumb');
                
                // Move cada vídeo para posições sequenciais a partir da posição 3
                $youtubeThumbs.each(function(index) {
                    var $youtubeThumb = $(this);
                    var targetPosition = 1 + index; // Posição 3 = índice 2, posição 4 = índice 3, etc.
                    $youtubeThumb.insertAfter($youtubeThumb.parent().children().eq(targetPosition));
                });

                $('.product-detail__header--photoArea-mobile-thumbs').slick({
                    infinite: false,
                    slidesToShow: 4,
                    vertical: false,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 374,
                            settings: {
                                slidesToShow: 5,
                            }
                        },
                    ]
                });
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();

        const sizeGuide = document.querySelector('.product-detail__size-guide');
        const label = document.querySelector('.product-radio-variation .label_attributes');
        if (sizeGuide && label) {
            label.append(sizeGuide);
        }

        const description = document.querySelector('.description-nav');
        if (description) {
            let navTab = Array.from(description.querySelectorAll('.nav-item'));
            let navShow = Array.from(description.querySelectorAll('.description-nav-content'));
        
            if (navTab.length && navShow.length) {
                navTab[0].classList.add('active');
                navShow[0].classList.add('active');
                const tabOpen = navTab[0].querySelector('.description-nav-tab-open');
                if (tabOpen) {
                    tabOpen.innerHTML = 'Fechar<i></i>';
                }
        
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');
        
                    navTab[index].classList.toggle('active');
                    navShow[index].classList.toggle('active');
        
                    const tabOpen = navTab[index].querySelector('.description-nav-tab-open');
        
                    if (tabOpen) {
                        tabOpen.innerHTML = isActive ? 'Abrir<i></i>' : 'Fechar<i></i>';
                    }
                }
        
                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
        
                window.addEventListener('resize', () => {}, { passive: true });
            }
        }        

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    const brinde = document.querySelector('#js_buy_together_api_layout_2');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });
        
        observer.observe(brinde, {
            childList: true,
            subtree: true
        });
        
    }

    const galleryCarrousel = document.querySelector('.gallery-carrousel');
    if(galleryCarrousel) {
        $('#product-photo').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 1000,
            vertical: false,
        });
    }

    $('.description-custom').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('#photo-fancy').fancybox();

    const buyTogether = document.querySelector('.product-detail__buy-together');

    if (buyTogether) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');
        
                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }else if(widget) {
                                widget.classList.add('no-variations');
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');
        
                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }else if(widget) {
                                widget.classList.add('no-variations');
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');
        
                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }else if(widget) {
                                widget.classList.add('no-variations');
                            }
                        }
                    }
                });
            });
        });
        
        observer.observe(buyTogether, {
            childList: true,
            subtree: true
        });
        
    }
})

function wrapIframesInDescription() {
    const description = document.querySelector('.content-product-detail .product-detail__description .description');
    if (description) {
        const descriptionLines = description.querySelectorAll('p')
    
        descriptionLines.forEach(description => {
            const iframes = description.querySelectorAll('iframe');
            if (iframes) {
                iframes.forEach(iframe => {
                    const wrapper = document.createElement('div');
                    wrapper.className = 'iframe-wrapper';
        
                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                });
            }        
        });
    }
}

wrapIframesInDescription();